import { createAction, ActionsUnion } from "../definitions";
import { OpenCabWorkflowActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OpenCabWorkflowActions = {
    setSkippedAssetSelection: (payload?: boolean) => createAction(OpenCabWorkflowActionTypes.SET_SKIPPED_ASSET_SELECTION, payload),
    clearSkippedAssetSelection: () => createAction(OpenCabWorkflowActionTypes.CLEAR_SKIPPED_ASSET_SELECTION),
    setPreTripDvirCompleteVehicleId: (payload?: string) => createAction(OpenCabWorkflowActionTypes.SET_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID, payload),
    clearPreTripDvirCompleteVehicleId: () => createAction(OpenCabWorkflowActionTypes.CLEAR_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID),
    setUserSkippedUnverifiedLogsDate: (userId: string, date: string) => createAction(OpenCabWorkflowActionTypes.SET_USER_SKIPPED_UNVERIFIED_LOGS_DATE, { [userId]: date }),
    clearUserSkippedUnverifiedLogsDate: (userId?: string) => createAction(OpenCabWorkflowActionTypes.CLEAR_USER_SKIPPED_UNVERIFIED_LOGS_DATE, userId),
    setUserLastSeenUncertifiedHosNotificationDate: (userId: string, date: string) =>
        createAction(OpenCabWorkflowActionTypes.SET_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE, { [userId]: date }),
    clearUserLastSeenUncertifiedHosNotificationDate: (userId: string) =>
        createAction(OpenCabWorkflowActionTypes.CLEAR_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE, userId)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type OpenCabWorkflowActions = ActionsUnion<typeof OpenCabWorkflowActions>;